export const modeTypeOptions = [
    {value: 'NO_VALVE', label: 'No Valve'},
    {value: 'MANUAL_OVERRIDE', label: 'Manual Override'},
    {value: 'LEARNING', label: 'Learning'},
    {value: 'LEARNING_DISABLE', label: 'Learning Disable'},
    {value: 'DISABLE', label: 'Disable'},
    {value: 'OVERRIDE', label: 'Override'},
    {value: 'NORMAL', label: 'Normal'}
];
